import axios from "axios";
import { attachAuthInterceptor } from "./authInterceptor";

const rmsClient = axios.create({
  baseURL: import.meta.env.VITE_RMS_API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

attachAuthInterceptor(rmsClient);

export default rmsClient;
